module.exports = __webpack_public_path__ + "img/homebanner4.aa39b9c1.png";